<template>
    <transition v-on:beforeEnter="beforeEnter" v-on:enter="enter" v-on:afterEnter="afterEnter" v-on:beforeLeave="beforeLeave" v-on:leave="leave" v-on:afterLeave="afterLeave" :css="false">
      <slot></slot>
    </transition>
</template>

<script>
  import VueScrollTo from 'vue-scrollto';
  export default {
    data () {
      return {
        functional: true,
        open: '100%',
        closed: '0%',
        top: 0,
        bottom: 0,
        amtIn: 0,
        amtOut: 0,
        amtRest: 0,
        wipe: 0.5,
        speed: 0.5,
        easeIn: Power1.easeIn,
        easeOut: Power1.easeOut
      }
    },
    mounted () {

    },
    methods: {
      cancelTween:function() {
        // TweenMax.to('.loading-bar', this.wipe, {width:'0vh', ease: this.easeIn,onComplete:this.afterTween});
        // TweenMax.set('.loading-bar', {position:'absolute' });
      },
      scrollToTop:function() {
         var options = {
          container: '#app',
          easing: 'ease-in',
          offset: -100,
          cancelable: true,
          x: false,
          y: true
        };
        var cancelScroll = VueScrollTo.scrollTo('#start', 500, options);
      },
      hideBar:function() {
        TweenMax.set('.loading-bar', {position:'fixed' });
        TweenMax.set('.loading-bar, .loading-bar .inner', {right:'0',left:'initial' });
        TweenMax.to('.loading-bar', this.wipe, {width:'100vh', ease: this.easeIn,onComplete:this.scrollToTop});
      },
      showBar:function() {
        TweenMax.set('.loading-bar, .loading-bar .inner', {left:'0',right:'initial' });
        TweenMax.to('.loading-bar', this.wipe, {width:'0vh', ease: this.easeOut,onComplete:this.afterTween});
      },
      beforeEnter: function(el) {
       this.hideBar();
      },
      enter: function(el,done) {
        console.log('enter');
        TweenMax.set(el, {position:'absolute'});
        TweenMax.fromTo(el, this.speed, {left:'200%'}, {left:'0%', ease: this.easeIn, delay:this.speed, onComplete:done});
      },
      afterEnter: function(el) {
        console.log('after enter');
        TweenMax.set(el, {position:'relative',transform:'none'});
        this.showBar();
      },
      enterCancelled: function(el) {
        this.hideBar();
      },
      beforeLeave: function(el) {
        console.log('before leave');
        this.$store.dispatch('setTransitionState',false);
      },
      leave: function(el,done) {
        console.log('leave');
        TweenMax.set(el, {position:'absolute'});
        // TweenMax.fromTo(el, this.speed, {x:'0%'}, {x:'-200%', ease: this.easeIn, onComplete:done});
        TweenMax.to(el, this.speed, {opacity:0, autoAlpha:0, ease: this.easeIn, onComplete:done});
      },
      afterLeave(el) {
        console.log('mask after leave');
        // TweenMax.set('.loading-bar, .loading-bar .inner', {left:'0',right:'initial' });
        // TweenMax.to('.loading-bar', this.wipe, {width:'0vh', ease: this.easeOut, onComplete:this.afterTween});
        // TweenMax.set(el, {position:'relative'});
        TweenMax.set(el, {position:'initial',transform:'none'});
      },
      leaveCancelled(el) {
        // TweenMax.set(el, {position:'relative'});
        // this.cancelTween();
      }
    }
  }
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/transitions/AppSlide.vue